module.exports = __webpack_public_path__ + "img/New Year 3.ce6b7521.jpeg";